"use strict";

import Snap from 'ol/interaction/Snap';

/**
 * Openlayers Implementierung eines Control zur Bereitstellung einer Snapfunktion für Vektorlayer.
 *
 * @class
 * @extends gc.gis.control.GCSnap
 * @memberof gc.gis.control
 * @author Christian Schmidt <c.schmidt@brain-scc.de>
 *
 * @param {Object} options Aufrufoptionen (siehe {@link gc.gis.control.GCAbstractMapControl})
 */
gc.gis.control.OLSnap = function(options)
{
	gc.gis.control.GCSnap.call(this, options);

	/**
	 * @type {ol.Map}
	 * @private
	 */
	this._ol_map = this._map.getMap().getImpl();

	/**
	 * @type {ol.interaction.Snap}
	 * @private
	 */
	this._ol_interaction = undefined;

	/**
	 * Vektor-Datenquelle, welche die Features zum Fangen lädt.
	 * @type {gc.gis.source.OLMapCatalogueVector}
	 * @private
	 */
	this._source = undefined;

	/**
	 * Layer welcher die Snap-Geometrien enthält.
	 * @type {gc.gis.layer.OLTrackingLayer}
	 * @private
	 */
	this._snapLayer = undefined;
};
gc.gis.control.OLSnap.prototype = Object.create(gc.gis.control.GCSnap.prototype);

/**
 * @inheritdoc
 */
gc.gis.control.OLSnap.prototype.init = function()
{
	this._snapLayer = new gc.gis.layer.OLTrackingLayer(this._map.getMap(), {});
	this._snapLayer.setStyle(gc.gis.iface.styleFactory.getStyle(gc.gis.factory.StyleType.TRANSPARENT));
	this._map.getMap().addTrackingLayer(this._snapLayer);
	this._snapLayer.setVisible(false);

	this._source = new gc.gis.source.OLMapCatalogueVector(this._map, {
		loadMessage: 'Lade Vektordaten für Fangfunktion ...'
	});
	this._snapLayer.getImpl().setSource(this._source.getSource());

	this._ol_interaction = new Snap({
		source: this._source.getSource(),
		vertex: (this._snapMode & gc.gis.control.GCSnapConstants.SNAP_VERTEX) > 0,
		edge: (this._snapMode & gc.gis.control.GCSnapConstants.SNAP_EDGE) > 0,
		pixelTolerance: this.PIXEL_TOLERANCE
	});

	this._initEvents();
};

/**
 * @inheritdoc
 */
gc.gis.control.OLSnap.prototype.isEnabled = function()
{
	return this._snapLayer.isVisible();
};

/**
 * @inheritdoc
 */
gc.gis.control.OLSnap.prototype.setSnapMode = function(mode)
{
	if (this._snapMode !== mode)
	{
		this._snapMode = mode;

		if (this.isEnabled())
		{
			this._ol_map.removeInteraction(this._ol_interaction);
		}

		this._ol_interaction = new Snap({
			source: this._source.getSource(),
			pixelTolerance: this.PIXEL_TOLERANCE,
			vertex: (this._snapMode & gc.gis.control.GCSnapConstants.SNAP_VERTEX) > 0,
			edge: (this._snapMode & gc.gis.control.GCSnapConstants.SNAP_EDGE) > 0
		});

		if (this.isEnabled())
		{
			this._ol_map.addInteraction(this._ol_interaction);
		}

		this._fireSnapPropsChanged();
	}
};

/**
 * @inheritdoc
 */
gc.gis.control.OLSnap.prototype.enable = function(active)
{
	if (active !== this.isEnabled())
	{
		if (active === true)
		{
			this._snapLayer.setVisible(true);
			this._ol_map.addInteraction(this._ol_interaction);
		}
		else
		{
			this._snapLayer.setVisible(false);
			this._ol_map.removeInteraction(this._ol_interaction);
		}

		this._fireSnapPropsChanged();
	}
};

/**
 * Initialisiert die Events für die Snapfunktion.
 *
 * @private
 */
gc.gis.control.OLSnap.prototype._initEvents = function()
{
	const self = this;
	gc.gis.control.GCSnap.prototype._initEvents.call(this);

	// Interaktionen der Karte überwachen.
	// Das Blöde ist, dass die Snap-Interation immer als letzes in der Interaktions-Liste enthalten sein muss. Da die
	// Reihenfolge der Ausführung entscheidend ist. Die Snap-Interaktion manipuliert nämlich das Browser-Event.
	this._ol_map.getInteractions().on('add', function(evt) {
		const interaction = evt.element;
		if (self._ol_interaction && self._ol_interaction !== interaction
			&& self._ol_map.getInteractions().item(self._ol_map.getInteractions().getLength()) !== self._ol_interaction)
		{
			if (self._ol_map.removeInteraction(self._ol_interaction))
			{
				self._ol_map.addInteraction(self._ol_interaction);
			}
		}
	});
};
